module.exports = __webpack_public_path__ + "static/4-b17842daece03db8393f36db13248192.jpg";